import { render, staticRenderFns } from "./singup.vue?vue&type=template&id=df97b528&scoped=true"
import script from "./singup.vue?vue&type=script&lang=js"
export * from "./singup.vue?vue&type=script&lang=js"
import style0 from "./singup.vue?vue&type=style&index=0&id=df97b528&prod&lang=scss&scoped=true"
import style1 from "./singup.vue?vue&type=style&index=1&id=df97b528&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df97b528",
  null
  
)

export default component.exports